export default () => ({
  slides: [
    {
      id: 1,
      title: 'Neu bei uns eingetroffen.',
      callToAction: 'Zu den neuen Weinen >',
      imageSrc: '/img/IMG_2137.jpg',
      top: '-200',
      left: '0',
    },
    {
      id: 2,
      title: 'Wein des Monats',
      callToAction: 'Zur Aktion >',
      imageSrc: '/img/IMG_2138.jpg',
      top: '-200',
      left: '0',
    },
    {
      id: 3,
      title: 'Unsere Veranstaltungen über das Jahr',
      callToAction: 'Zu den Veranstaltungen >',
      imageSrc: '/img/IMG_2139.jpg',
      top: '-200',
      left: '0',
    },
    {
      id: 4,
      title: 'Wein des Monats (2)',
      callToAction: 'Zur Aktion >',
      imageSrc: '/img/IMG_2138.jpg',
      top: '-200',
      left: '0',
    },
    {
      id: 5,
      title: 'Unsere Veranstaltungen über das Jahr (2)',
      callToAction: 'Zu den Veranstaltungen >',
      imageSrc: '/img/IMG_2139.jpg',
      top: '-200',
      left: '0',
    },
  ],
})
